import React, {Fragment, useEffect, useState} from "react";
import {Field, useForm, useFormState} from "react-final-form";
import {useSelector} from "react-redux";
import usePrice from "../../hooks/usePrice";
import useCalculator from "../../hooks/useCalculator";
import {APPLY_STATUS_SUCCESS} from "../../actions/ApplyFieldActions";
import {COUPON_TYPE_PRICE} from "../../constants/CouponTypeConstant";
import QueryStorage from "../../../../../common/helpers/QueryStorage";

function WriterLevel({ selectedValue, setSelectedValue, resetFreeSelectedValue }) {
    const options = useSelector(state => state.orderOptions.data.writerLevel);
    const {coupon} = useSelector(state => state.applyField);
    const {priceFormat} = usePrice();
    const {calculateWriterPricePerPage, calculateOriginalWriterPricePerPage} = useCalculator();
    const {values} = useFormState();
    const {change} = useForm();
    const [isDisabled, setIsDisabled] = useState();

    const handleRadioChange = (e) => {
        values.freeAuthorCategory = undefined;
        setSelectedValue(e.target.value);
        resetFreeSelectedValue();
    };

    useEffect(() => {
        const savedAuthorCategory = QueryStorage.get("authorCategory");
        if (savedAuthorCategory) {
            change("authorCategory", savedAuthorCategory);
            setSelectedValue(savedAuthorCategory);
        }
    }, [change]);

    useEffect(() => {
        setIsDisabled(values.authorCategory === options.preferredWriter.value);
    }, [change, values.authorCategory]);

    useEffect(() => {
        if (values.authorCategory !== undefined) {
            QueryStorage.set("authorCategory", values.authorCategory);
            QueryStorage.remove("freeAuthorCategory");
        }
    }, [values.authorCategory]);

    const showPrice = writerLevelItem => {
        let price;

        if (coupon && coupon.status === APPLY_STATUS_SUCCESS && coupon.data.type === COUPON_TYPE_PRICE) {
            price = calculateOriginalWriterPricePerPage(writerLevelItem);
        } else {
            price = calculateWriterPricePerPage(writerLevelItem);
        }

        if (!price) {
            return 'Free';
        }

        return (
            <Fragment>
                + {priceFormat(price)}
                <span>per page</span>
            </Fragment>
        );
    };

    if (values.authorCategory === options.preferredWriter.value) return '';

    return (
        <div className="form-group">
            <div className="form-label">Writer levels</div>
            <div className="wt-level-items">
                {[options.regular, options.advanced, options.premiumWriter].map((levelOption, index) => (
                    <label
                        key={levelOption.value}
                        className={`wt-level-item wt-level-item-${index + 1} ${
                            selectedValue === levelOption.value ? 'wt-level-item-selected' : ''
                        }`}
                        style={isDisabled ? {pointerEvents: 'none'} : {}}
                    >
                        <div className="wt-level-item__rating">
                            {Array(index + 1).fill().map((_, i) => (
                                <img key={i} src="/_core/assets/themes/v5/assets/img/form3/star-new.svg" alt="" />
                            ))}
                        </div>
                        <h5 className="wt-level-item__title">{levelOption.label}</h5>
                        <div className="wt-level-item__info">{showPrice(levelOption)}</div>
                        <div className="wt-level-item__descr">
                            <p>
                                {index === 0 && 'Any writer who is available for your assignment at the moment.'}
                                {index === 1 && 'Experienced writer with a high satisfaction rate. A much deeper understanding of various subjects and advanced skills to cope with complex tasks.'}
                                {index === 2 && 'Top quality writer from an English speaking country. Advanced vocabulary and style of writing.'}
                            </p>
                        </div>
                        <Field
                            name="authorCategory"
                            type="radio"
                            component="input"
                            value={levelOption.value}
                            disabled={isDisabled}
                            onClick={handleRadioChange}
                        />
                        <span className="checkbox-default__checkmark">
                            <div className="checkbox-default__checkmark-icon">
                                <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt="" />
                            </div>
                        </span>
                    </label>
                ))}
            </div>
        </div>
    );
}

export default WriterLevel;
